import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { label: "首页", to: "/" },
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "搜索视频", to: "/search" },
  { label: "关于我们", to: "/about" },
];

const FRIEND_LINKS = ["光影资料库", "银幕指南", "追剧日历", "综艺观察", "观影手记"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-secondary-200 bg-secondary-100">
      <div className="px-4 py-12 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                密桃<span className="text-primary-600">视频</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              密桃视频是一个高清视频内容聚合展示平台，汇聚电影、电视剧、综艺等丰富资源，
              帮助您轻松浏览、筛选并发现优质视频内容。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-foreground-900">
              快速导航
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-foreground-900">
              友情链接
            </h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {FRIEND_LINKS.map((name) => (
                <li key={name}>
                  <span className="inline-block rounded-md border border-secondary-200 bg-secondary-50 px-3 py-1 text-xs text-foreground-600">
                    {name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-600">
            本站为内容展示与前端演示平台，所有视频资料、封面及文案均为原创示范数据，仅供浏览参考，
            不提供在线播放服务。如涉及版权问题请联系我们处理。
          </p>
          <p className="mt-3 text-xs text-foreground-500">
            © 2024 密桃视频 · 高清视频内容平台　|　内容仅供学习与交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}